import { render, staticRenderFns } from "./FormRequestDetailHeader.vue?vue&type=template&id=34427ab4&scoped=true"
import script from "./FormRequestDetailHeader.vue?vue&type=script&lang=js"
export * from "./FormRequestDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34427ab4",
  null
  
)

export default component.exports